import { Router } from '@angular/router';
import { BaseComponent } from './../../../../shared/Components/base/base.component';
import { HomesService } from './../../services/homeService';
import { Component, HostListener, OnInit } from '@angular/core';

interface TreeNode<T> {
  data: T;
  children?: TreeNode<T>[];
  expanded?: boolean;
}

interface FSEntry {
  name: string;
  size: string;
  kind: string;
  items?: number;
  action?: boolean;
}

@Component({
  selector: 'ngx-policies',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent extends BaseComponent implements OnInit {
  finish: boolean = false;
  isMobile: boolean = window.innerWidth < 600;
  isTablet: boolean = window.innerWidth < 991;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobile = window.innerWidth < 600;
    this.isTablet = window.innerWidth < 991;
  }
  home: Home;

  // options
  useGradient: boolean = true;
  showLegend: boolean = true;
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';

  single = ([] = []);
  //**  charts global options */
  showXAxis = true;
  showYAxis = true;
  showXAxisLabel = true;
  showYAxisLabel = true;

  //**chart users options */
  viewSizeUsers: any[] = [undefined, 400];
  viewSizeServicesMobile: any[] = [300, 400];
  viewSizeServicesTablet: any[] = [420, 400];
  beneficaries = [];
  xAxisLabelUsers = 'أنواع المستفيدين';
  yAxisLabel = 'عدد الخدمات';

  //**chart Services options */
  viewSizeServices: any[] = [undefined, 400];
  viewSizeUsersMobile: any[] = [300, 400];
  viewSizeUsersTablet: any[] = [450, 400];
  types = [];
  xAxisLabelServices = 'أنواع الخدمات';

  constructor(public service: HomesService, private rout: Router) {
    super(rout, service);
    Object.assign(this, {});

    this.home = {} as Home;
  }

  // colorScheme = {
  //   domain: ['gray', 'orange', 'green', 'blue', , '#a8385d', '#aae3f5'],
  // };
  colorScheme = {
    domain: ['#A8C4D0', '#A8C4D0', '#A8C4D0', '#A8C4D0', '#A8C4D0', '#A8C4D0', '#A8C4D0'],
  };

  colorScheme2 = {
    domain: ['orange'],
  };

  colorSchemeNumber = {
    domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5'],
  };
  cardColor: string = '#232837';
  data = [];

  ngOnInit() {
    this.service.getData('').subscribe((res) => {
      this.home = res;
      console.log('res', res);

      // this.single.push({ name: 'الخدمات المعلوماتية', value: this.home.servicesInfoCount });
      // this.single.push({ name: ' الخدمات التكاملية', value: this.home.servicesIntegrationCount });
      // this.single.push({ name: 'الخدمات الاجرائية', value: this.home.servicesExecutopnCount });
      // this.single.push({ name: 'الخدمات التفاعلية', value: this.home.servicespractisCount });
      this.single.push({ name: ' عدد الخدمات الالكترونية', value: this.home.servicesCount });

      this.data.push({ name: 'الخدمات التي وصلت الى أعلي نضج', value: this.home.servicespractisCount });
      this.data.push({ name: 'أنواع الخدمات', value: this.home.servicespractisCount });
      this.data.push({ name: 'أنواع المستفيدين', value: this.home.servicespractisCount });

      res.benficiariesServices.forEach((element) => {
        this.beneficaries.push({ name: element.key, value: element.context });
      });

      res.typesServices.forEach((element) => {
        this.types.push({ name: element.key.replace('طلب', ''), value: element.context });
      });
      this.finishLoading = true;
    });
  }
}
